import { z } from 'zod'
import { PaymentStatusSchema } from './payment'

/**
 * Refill Status Schema
 */
export const RefillStatusSchema = z
  .enum(['upcoming', 'due', 'locked', 'processing', 'failed', 'completed'])
  .meta({ id: 'RefillStatus' })

export type RefillStatus = z.infer<typeof RefillStatusSchema>

/**
 * Refill Schema
 */
export const RefillSchema = z
  .object({
    id: z.string(),
    orderId: z.string(),
    patientId: z.string(),
    patientName: z.string().optional(),
    status: RefillStatusSchema,
    supplyEndDate: z.iso.date(),
    lockWindowStart: z.iso.date().optional(),
    paymentStatus: PaymentStatusSchema.optional(),
  })
  .meta({ id: 'Refill' })

export type Refill = z.infer<typeof RefillSchema>

/**
 * Refill Filters Schema
 */
export const RefillFiltersSchema = z
  .object({
    status: RefillStatusSchema.optional(),
    page: z.number().int().positive().default(1),
    limit: z.number().int().positive().max(100).default(50),
  })
  .meta({ id: 'RefillFilters' })

export type RefillFilters = z.infer<typeof RefillFiltersSchema>
